module.exports = "/_next/static/images/video_id_7113318115609627950-2c72b84c32b072f7fb40d503fb29a132.jpg";